import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Avatar,
  Typography,
  CardActions,
  IconButton,
  Button,
  Box,
  TextField,
  Popover,
  MenuItem,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
} from "@mui/material";
// import FeedViewModal from "../../../../Community/FeedViewModal";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  deleteFeed,
  deleteFeedComment,
  deleteFeedCommentReplay,
  getFeedComment,
  getFeeds,
  getMyFeeds,
  getSingleFeed,
  postFeedCommentReplay,
  updateFeed,
  updateFeedComment,
  updateFeedCommentReplay,
} from "../../../../Redux/Reducers/communityReducer";
// import useFeedActions from "../../../../Community/FeedsHandle/useFeedActions";
import { useUserDetailContext } from "../../../UserDetailContext";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import TelegramIcon from "@mui/icons-material/Telegram";
import TurnedInNotRoundedIcon from "@mui/icons-material/TurnedInNotRounded";
// import useFeedActions from "./FeedsHandle/useFeedActions";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FeedViewModal from "./FeedViewModal";
import { useNavigate } from "react-router-dom";
import { ShareProfile } from "../../MyProfileDetails/ProfileConnectionComponents";
import CreateFeedModal from "./CreateFeedModal";
import useFeedActions from "../FeedsHandle/useFeedActions";
import { useQuantityContext } from "../../../QuantityContext";
import { Helmet } from "react-helmet";
import usePagination from "./usePagination";

const FeedCard = ({ item , onEdit, onDelete}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const exploreType = useSelector((state) => state?.community?.exploreType);
  const {
    data: feedsData,
    loading: loadingFeeds,
    hasMore,
    handleLoadMore,
    handleRefresh,
  } = usePagination((state) => state.community.feeds, getFeeds, {
    type: exploreType,
  });
  const {
    author,
    id: postId,
    likes_count,
    content,
    media,
    comments_count,
  } = item || {};

  // console.log("feedsDataNNNN", feedsData)
   const { openSnackbar } = useQuantityContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [editingComment, setEditingComment] = useState(null);
  const [editingReply, setEditingReply] = useState(null);
  const [isCommentBoxOpen, setIsCommentBoxOpen] = useState(false);
  const commentsReducer = useSelector((state) => state.community.comments);
  const commentsData = commentsReducer?.comments;
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");
  const { userDetails } = useUserDetailContext();
  const userRefId = userDetails.reference_id;
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const contentRef = useRef();
  const isPostAuthor = userRefId === author?.user_ref_id;
  const [comments, setComments] = useState([]);
  const [feeds, setFeeds] = useState(feedsData || []);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editContent, setEditContent] = useState(item?.content || "");
  const [editMedia, setEditMedia] = useState(item?.media || []);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  //   console.log("comments", comments);
 const [localLiked, setLocalLiked] = useState(item?.has_liked);
  const [localLikesCount, setLocalLikesCount] = useState(item?.likes_count);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [localCommentsCount, setLocalCommentsCount] = useState(item?.comments_count || 0);

 useEffect(() => {
  // Update local state when item prop changes
  setLocalLiked(item?.has_liked);
  setLocalLikesCount(item?.likes_count);
  setLocalCommentsCount(item?.comments_count);
}, [item]);

const handleLikeOptimistic = async () => {
  // Capture current state BEFORE updating
  const currentLiked = localLiked;
  const currentLikesCount = localLikesCount;

  // Optimistically update UI
  setLocalLiked(!currentLiked);
  setLocalLikesCount(currentLiked ? currentLikesCount - 1 : currentLikesCount + 1);

  try {
    await handleLike();
  } catch (error) {
    // Revert on error
    setLocalLiked(currentLiked);
    setLocalLikesCount(currentLikesCount);
  }
}

  const {
    handleLike,
    handleLikeComment,
    handleFeedCommentReplyLike,
    handleSendComment,
    handleSendReply,
    handleDeleteCommentOptimistic
  } = useFeedActions(postId, comments, setComments, feeds, setFeeds);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDeleteModal = () => {
    setIsDeleteModalOpen(true);
    handlePopoverClose();
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  // Show more/less button logic
  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      const lineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
      const maxH = lineHeight * 3;
      setIsButtonVisible(el.scrollHeight > maxH);
    }
  }, [content, expanded]);

  useEffect(() => {
    setFeeds(feedsData);
    setComments(commentsData);
  }, [feedsData, commentsData]);

  const handleEditClick = () => {
    const formattedMedia = item?.media?.map((mediaItem) => ({
      url: mediaItem.url,
      type:
        mediaItem.type || (mediaItem.url.includes(".mp4") ? "video" : "image"),
    }));
    setEditContent(item?.content || "");
    setEditMedia(formattedMedia || []);
    setIsEditModalOpen(true);
    handlePopoverClose();
  };

  const handleDeleteClick = async () => {
    try {
      const res = await dispatch(deleteFeed(postId)); // Call delete API
      if (res?.payload?.statusCode == 200) {
        await dispatch(getMyFeeds({ type: exploreType })); // Refresh feeds
      }
    } catch (error) {
      console.error("Error deleting feed:", error);
    }
    setIsDeleteModalOpen(false);
    handlePopoverClose();
  };

  // Only fetch comments if modal is not already open
  const handleImageClick = async (item, imgIdx = 0) => {
    setSelectedFeed({ ...item, imgIdx });
     await dispatch(getFeeds({type: exploreType}));
     await dispatch(getSingleFeed(postId));
    if (!modalOpen) {
       
      await dispatch(getFeedComment(postId));
     
     
      // setModalOpen(true);
      navigate(`/explore/feeds/${postId}`, { state: { fromFeedId: postId } });
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedFeed(null);
    // navigate(-1);
  };

  const handleToggle = () => setExpanded((prev) => !prev);

  const handleToggleCommentBox = async () => {
    if (!isCommentBoxOpen) {
      await dispatch(getFeedComment(postId));
    }
    setIsCommentBoxOpen((prev) => !prev);
  };

const handleAddComment = async () => {
  if (commentText.trim()) {
    // Optimistic update
    const newComment = {
      id: Date.now(), // Temporary ID
      content: commentText,
      author: {
        name: userDetails.name,
        profile_pic: userDetails.profile_pic,
        designation: userDetails.designation,
        user_ref_id: userDetails.reference_id
      },
      created_at: new Date().toISOString(),
      likes_count: 0,
      has_liked: false,
      replies: [],
      replies_count: 0
    };

    setComments(prev => [newComment, ...prev]); // Add comment optimistically
    setLocalCommentsCount(prev => prev + 1);
    
    const success = await handleSendComment(commentText);
    
    if (success) {
      setCommentText("");
    } else {
      // Rollback if failed
      setComments(prev => prev.filter(c => c.id !== newComment.id));
      setLocalCommentsCount(prev => prev - 1);
    }
  }
};

  const handleEditComment = async (postId, commentId) => {
    if (editingComment?.text.trim()) {
      const params = {
        id: postId,
        commentId: commentId,
        content: editingComment.text,
      };
      try {
        const res = await dispatch(updateFeedComment(params));
        if (res?.payload?.statusCode === 200) {
          dispatch(getFeedComment(postId));
        }
      } finally {
        setEditingComment(null);
      }
    }
  };

const handleDeleteComment = async (postId, commentId) => {
  try {
    const res = await dispatch(
      deleteFeedComment({ id: postId, commentId: commentId })
    );
    if (res?.payload?.statusCode === 200) {
      dispatch(getFeedComment(postId));
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error deleting comment:", error);
    return false;
  }
};

  const handleReplyToggle = (commentId) => {
    setReplyingTo((prev) => (prev === commentId ? null : commentId));
  };

  const handleAddReply = async (postId, commentId) => {
    if (replyText.trim()) {
      try {
        const params = {
          id: postId,
          commentId: commentId,
          content: replyText,
        };
        const res = await dispatch(postFeedCommentReplay(params));
        if (res?.payload?.statusCode === 201) {
          setReplyText("");
          setReplyingTo(null);
          await dispatch(getFeedComment(postId));
        }
      } catch {}
    }
  };

  const handleEditReply = async (postId, commentId, replyId) => {
    if (editingReply?.text.trim()) {
      const params = {
        id: postId,
        commentId: commentId,
        replyId: replyId,
        content: editingReply.text,
      };
      try {
        const res = await dispatch(updateFeedCommentReplay(params));
        if (res?.payload?.statusCode === 200) {
          dispatch(getFeedComment(postId));
        }
      } finally {
        setEditingReply(null);
      }
    }
  };

  const handleDeleteCommentReplay = async (postId, commentId, replyId) => {
    const params = { id: postId, commentId: commentId, replyId: replyId };
    const res = await dispatch(deleteFeedCommentReplay(params));
    if (res?.payload?.statusCode === 200) {
      dispatch(getFeedComment(postId));
    }
  };

  const handleUpdatePost = async (updatedContent, updatedMedia) => {
    const payload = new FormData();
    payload.append("content", updatedContent);
    payload.append("is_visible", true);

    updatedMedia.forEach((mediaItem) => {
      if (mediaItem.file) {
        payload.append("media", mediaItem.file);
      } else {
        payload.append("existing_media", mediaItem.preview);
      }
    });

    try {
      const res = await dispatch(updateFeed({ postId, data: payload }));
      if (res?.payload?.statusCode === 200) {
        await dispatch(getMyFeeds({ type: exploreType }));
      }
      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error updating feed:", error);
    }
  };

  const handleShareEvent = () => {
  setShareModalOpen(true);
};


  const renderMedia = (media, idx, borderRadius = 1) => {
    if (media.type.includes("video")) {
      return (
        <video
          src={media.url}
          controls
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: 8,
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleImageClick(item, idx);
          }}
        />
      );
    } else if (media.type.includes("pdf")) {
      return (
        <Box
          onClick={() => handleImageClick(item, idx)}
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
            cursor: "pointer",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <PictureAsPdfIcon sx={{ fontSize: 48, color: "#f44336" }} />
            <Typography variant="caption" display="block">
              PDF Document
            </Typography>
          </Box>
        </Box>
      );
    } else {
      return (
        <CardMedia
          component="img"
          image={media?.url}
          alt="media"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 1,
            cursor: "pointer",
            border:"0.5px solid #d1d5db"
          }}
          onClick={() => handleImageClick(item, idx)}
        />
      );
    }
  };

  const formatTimeAgo = (dateString) => {
    const now = new Date();
    const createdDate = new Date(dateString);
    const seconds = Math.floor((now - createdDate) / 1000);

    // Define time intervals in seconds
    const intervals = {
      year: 31536000, // 365 days
      month: 2592000, // 30 days
      week: 604800, // 7 days
      day: 86400, // 24 hours
      hour: 3600, // 60 minutes
      minute: 60,
    };

    // Calculate time differences
    if (seconds < 10) return "just now";
    if (seconds < 60) return `${seconds}s`;

    if (seconds < intervals.hour) {
      const minutes = Math.floor(seconds / intervals.minute);
      return `${minutes}m`;
    }

    if (seconds < intervals.day) {
      const hours = Math.floor(seconds / intervals.hour);
      return `${hours}h`;
    }

    if (seconds < intervals.week) {
      const days = Math.floor(seconds / intervals.day);
      return `${days}d`;
    }

    if (seconds < intervals.month) {
      const weeks = Math.floor(seconds / intervals.week);
      return `${weeks}w`;
    }

    if (seconds < intervals.year) {
      const months = Math.floor(seconds / intervals.month);
      return `${months}mo`;
    }

    const years = Math.floor(seconds / intervals.year);
    return `${years}y`;
  };

  const formatOPostTimeAgo = (dateString) => {
    const now = new Date();
    const createdDate = new Date(dateString);
    const seconds = Math.floor((now - createdDate) / 1000);

    // Define time intervals in seconds
    const intervals = {
      year: 31536000, // 365 days
      month: 2592000, // 30 days
      week: 604800, // 7 days
      day: 86400, // 24 hours
      hour: 3600, // 60 minutes
      minute: 60,
    };

    // Calculate time differences
    if (seconds < 10) return "just now";
    if (seconds < 60) return `${seconds}s`;

    if (seconds < intervals.hour) {
      const minutes = Math.floor(seconds / intervals.minute);
      return `${minutes} minutes ago`;
    }

    if (seconds < intervals.day) {
      const hours = Math.floor(seconds / intervals.hour);
      return `${hours} hours ago`;
    }

    if (seconds < intervals.week) {
      const days = Math.floor(seconds / intervals.day);
      return `${days} days ago`;
    }

    if (seconds < intervals.month) {
      const weeks = Math.floor(seconds / intervals.week);
      return `${weeks} weeks ago`;
    }

    if (seconds < intervals.year) {
      const months = Math.floor(seconds / intervals.month);
      return `${months} months ago`;
    }

    const years = Math.floor(seconds / intervals.year);
    return `${years} years ago`;
  };


  const handleShareSuccess = (msg) => {
  // Optionally show a snackbar or toast
  openSnackbar(msg, "success", 3000);
};

const handleShareFailure = (msg) => {
  // Optionally show a snackbar or toast
  openSnackbar(msg, "success", 3000);
};

  return (
    <>
    {shareModalOpen && item && (
  <Helmet>
    <meta property="og:title" content={item.content?.substring(0, 100) || "Post on NEOIN"} />
    <meta property="og:description" content={`Posted by ${item.author?.name}`} />
    <meta property="og:image" content={item.media?.[0]?.url || author?.profile_pic} />
    <meta property="og:url" content={`${window.location.origin}/explore/feeds/${item.id}`} />
    <meta property="og:type" content="article" />
  </Helmet>
)}
      <Card sx={{ width: "100%", mb: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <CardHeader
            avatar={<Avatar src={author?.profile_pic} />}
            title={
              <Typography align="left" sx={{ width: "100%" }}>
                {author?.name}
              </Typography>
            }
            subheader={
              <>
              <Typography variant="body2" align="left" sx={{ width: "100%", fontSize: "0.6rem" }}>
                {author?.designation}
              </Typography>
              <Typography variant="body2" align="left" sx={{ width: "100%", fontSize: "0.6rem" }}>
               {formatOPostTimeAgo(item?.created_at)}
              </Typography>
              </>
            }
            
          />
          {item?.is_my_post ? (
            <Box
              sx={{ p: "10px", cursor: "pointer" }}
              onClick={handlePopoverOpen}
            >
              <MoreVertIcon />
            </Box>
          ) : (
            ""
          )}
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem onClick={handleEditClick}>Edit</MenuItem>
            <MenuItem onClick={handleOpenDeleteModal}>Delete</MenuItem>
          </Popover>
        </Box>
        <CardContent>
        <Typography
  onClick={(e) => {
    e.stopPropagation();
    handleImageClick(item);
  }}
  ref={contentRef}
  variant="body1"
  sx={{
    display: "-webkit-box",
    WebkitLineClamp: expanded ? "none" : 6,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
    whiteSpace: "pre-line", 
  }}
>
  {content || ""}
</Typography>
          {isButtonVisible && (
            <Button onClick={handleToggle} size="small">
              {expanded ? "Show less" : "Show more"}
            </Button>
          )}
        </CardContent>
        {media && media?.length > 0 && (
          <>
            {media?.length === 3 ? (
              <Grid container spacing={1} sx={{ p: 1, height: 240 }}>
                <Grid item xs={6} sx={{ height: "100%", position: "relative" }}>
                  {renderMedia(media[0], 0, 8)}
                </Grid>
                <Grid item xs={6} sx={{ height: "100%" }}>
                  <Grid
                    container
                    direction="column"
                    spacing={1}
                    sx={{ height: "100%" }}
                  >
                    <Grid item sx={{ height: "50%", position: "relative",  }}>
                      {renderMedia(media[1], 1)}
                    </Grid>
                    <Grid item sx={{ height: "50%", position: "relative"  }}>
                      {renderMedia(media[2], 2)}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={1} sx={{ p: 1 , height: media?.length === 1 ? '400px' : 'auto'}}>
                {media?.slice(0, 4).map((m, idx) => (
                  <Grid
                    item
                    xs={media?.length === 1 ? 12 : 6}
                    key={m?.id}
                    sx={{ position: "relative",  height: media?.length === 1 ? '100%' : '200px' }}
                  >
                    {renderMedia(m, idx)}
                    {media?.length > 4 && idx === 3 && (
                      <Box
                        onClick={(e) => {
    e.stopPropagation();
    handleImageClick(item, 3); // Pass the index 3 since this overlay appears on the 4th image
  }}
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          bgcolor: "rgba(0,0,0,0.4)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: 24,
                          fontWeight: "bold",
                          borderRadius: 1,
                          cursor: "pointer", // Add cursor pointer to indicate clickable
    '&:hover': {
      bgcolor: "rgba(0,0,0,0.5)", // Optional: darken overlay on hover
    },
                        }}
                      >
                        +{media?.length - 4}
                      </Box>
                    )}
                  </Grid>
                ))}
              </Grid>
            )}
          </>
        )}
        <CardActions
          disableSpacing
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box>
            <IconButton
              onClick={handleLikeOptimistic}
              sx={{
                transition: "transform 0.2s",
                "&:active": { transform: "scale(1.2)" },
              }}
            >
              {localLiked ? (
                <Favorite color="error" />
              ) : (
                <FavoriteBorder />
              )}
              <Typography sx={{ ml: 0.5 }}>{localLikesCount}</Typography>
            </IconButton>
            <IconButton onClick={handleToggleCommentBox}>
              <ChatBubbleOutlineRoundedIcon />
              <Typography sx={{ ml: 0.5 }}>{localCommentsCount}</Typography>
            </IconButton>
            <IconButton 
             size="small"
            onClick={(e) => {
    e.stopPropagation();
    handleShareEvent();
  }}
            >
              <TelegramIcon />
            </IconButton>
          </Box>
          <Box>
            {/* <TurnedInNotRoundedIcon /> */}
          </Box>
        </CardActions>
        {isCommentBoxOpen && (
          <Box
            sx={{
              maxHeight: "50vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
              postion: "relative",
              borderTop: "1px solid #e0e0e0",
              bgcolor: "#fafafa",
            }}
          >
             {/* New Comment Input */}
              <Box
    sx={{
      position: "sticky",
      top: 0,
      zIndex: 1,
      bgcolor: "#fafafa",
      pt: 2,
      pb: 2,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", px: 2 }}>
      <TextField
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
        onKeyDown={(e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault(); // Prevents new line
        handleAddComment(); // 👈 Called on Enter
      }
    }}
        size="small"
        fullWidth
        placeholder="Add a comment..."
      />
      <Button
        onClick={handleAddComment}
        sx={{ ml: 1, textTransform: "none" }}
      >
        Send
      </Button>
    </Box>
  </Box>
  <Box sx={{ overflowY: "auto", maxHeight: "calc(50vh - 80px)", p: 2 }}>
            {commentsData?.map((comment) => (
              <Box key={comment?.id} sx={{ mb: 2 }}>
                
                <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>
                  <Avatar
                    src={comment?.author?.profile_pic}
                    sx={{
                      mr: 1.5,
                      width: 32,
                      height: 32,
                      border: "1px solid #e0e0e0",
                    }}
                  />
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "left",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, textTransform: "capitalize" }}
                      >
                        {comment?.author?.name}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: "0.7rem",
                          color: "text.secondary",
                          ml: "10px",
                        }}
                      >
                        {formatTimeAgo(comment?.created_at)}
                      </Typography>
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: "light",
                      }}
                    >
                      {comment?.author?.designation}
                    </Typography>
                    {/* Comment Content */}
                    {editingComment?.id === comment?.id ? (
                      <Box sx={{ display: "flex", mt: 1 }}>
                        <TextField
                          value={editingComment?.text}
                          onChange={(e) =>
                            setEditingComment((prev) => ({
                              ...prev,
                              text: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault(); // Prevents new line
       handleEditComment(postId, comment?.id)
      }
    }}
                          size="small"
                          fullWidth
                          autoFocus
                        />
                        <Button
                          onClick={() => handleEditComment(postId, comment?.id)}
                          sx={{ ml: 1 }}
                        >
                          Save
                        </Button>
                      </Box>
                    ) : (
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {comment?.content}
                      </Typography>
                    )}
                  </Box>
                </Box>
                {/* Like/Reply Actions */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    ml: 5,
                    mt: 0.5,
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => handleLikeComment(postId, comment?.id)}
                  >
                    {comment?.has_liked ? (
                      <Favorite color="error" fontSize="small" />
                    ) : (
                      <FavoriteBorder fontSize="small" />
                    )}
                  </IconButton>
                  <Typography variant="caption" sx={{ mr: 2 }}>
                    {comment?.likes_count || 0}
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => handleReplyToggle(comment?.id)}
                    sx={{ textTransform: "none", fontSize: "0.8rem" }}
                  >
                    Reply ({comment?.replies_count || 0})
                  </Button>
                  {!editingComment && (
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {comment?.author?.user_ref_id === userRefId && (
                        <Button
                          size="small"
                          onClick={() =>
                            setEditingComment({
                              id: comment?.id,
                              text: comment?.content,
                            })
                          }
                          sx={{
                            textTransform: "none",
                            fontSize: "0.8rem",
                            minWidth: 0,
                            padding: 0,
                          }}
                        >
                          Edit
                        </Button>
                      )}
                      {(comment?.author?.user_ref_id === userRefId ||
                        isPostAuthor) && (
                        <Button
                          size="small"
  
                          // onClick={() =>
                          //   handleDeleteComment(postId, comment?.id)
                          // }
                           onClick={() => handleDeleteCommentOptimistic(comment?.id, setLocalCommentsCount)}
                          sx={{
                            textTransform: "none",
                            fontSize: "0.8rem",
                            minWidth: 0,
                            padding: 0,
                            color: "error.main",
                          }}
                        >
                          Delete
                        </Button>
                      )}
                    </Box>
                  )}
                </Box>
                {/* Replies Section */}
                {comment?.replies?.length > 0 && (
                  <Box
                    sx={{
                      ml: 4.5,
                      borderLeft: "2px solid #e0e0e0",
                      pl: 2,
                      mt: 1,
                    }}
                  >
                    {comment?.replies?.map((reply) => (
                      <Box key={reply?.id} sx={{ mb: 1.5, mt: 1.5 }}>
                        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                          <Avatar
                            src={reply?.author?.profile_pic}
                            sx={{
                              mr: 1.5,
                              width: 28,
                              height: 28,
                              border: "1px solid #e0e0e0",
                            }}
                          />
                          <Box sx={{ flex: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 600, fontSize: "0.9rem" }}
                              >
                                {reply?.author?.name}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "text.secondary",
                                  ml: 1.5,
                                  fontSize: "0.65rem",
                                }}
                              >
                                {formatTimeAgo(reply?.created_at)}
                              </Typography>
                            </Box>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: "light",
                              }}
                            >
                              {reply?.author?.designation}
                            </Typography>
                            {editingReply?.id === reply?.id ? (
                              <Box sx={{ display: "flex", mt: 1 }}>
                                <TextField
                                  value={editingReply?.text}
                                  onChange={(e) =>
                                    setEditingReply((prev) => ({
                                      ...prev,
                                      text: e.target.value,
                                    }))
                                  }
                                  size="small"
                                  fullWidth
                                  autoFocus
                                />
                                <Button
                                  onClick={() =>
                                    handleEditReply(
                                      postId,
                                      comment?.id,
                                      reply?.id
                                    )
                                  }
                                  sx={{ ml: 1 }}
                                >
                                  Save
                                </Button>
                              </Box>
                            ) : (
                              <Typography variant="body2" sx={{ mt: 0.5 }}>
                                {reply?.content}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            ml: 5,
                            mt: 0.5,
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleFeedCommentReplyLike(comment?.id, reply?.id)
                            }
                          >
                            {reply?.has_liked ? (
                              <Favorite color="error" fontSize="small" />
                            ) : (
                              <FavoriteBorder fontSize="small" />
                            )}
                          </IconButton>
                          <Typography variant="caption" sx={{ mr: 2 }}>
                            {reply?.likes_count || 0}
                          </Typography>
                          {(reply?.is_my_comment || isPostAuthor) &&
                            !editingReply && (
                              <Box sx={{ display: "flex", gap: 1 }}>
                                {/* Only show Edit if it's my reply */}
                                {reply?.is_my_comment && (
                                  <Button
                                    size="small"
                                    onClick={() =>
                                      setEditingReply({
                                        id: reply?.id,
                                        text: reply?.content,
                                      })
                                    }
                                    sx={{
                                      textTransform: "none",
                                      fontSize: "0.8rem",
                                      minWidth: 0,
                                      padding: 0,
                                    }}
                                  >
                                    Edit
                                  </Button>
                                )}
                                {/* Show Delete only if it's my reply or I am the post author */}
                                {(reply?.is_my_comment || isPostAuthor) && (
                                  <Button
                                    size="small"
                                    onClick={() =>
                                      handleDeleteCommentReplay(
                                        postId,
                                        comment?.id,
                                        reply?.id
                                      )
                                    }
                                    sx={{
                                      textTransform: "none",
                                      fontSize: "0.8rem",
                                      minWidth: 0,
                                      padding: 0,
                                      color: "error.main",
                                    }}
                                  >
                                    Delete
                                  </Button>
                                )}
                              </Box>
                            )}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}
                {/* Reply Input */}
                {replyingTo === comment?.id && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mt: 1.5,
                      ml: 5,
                    }}
                  >
                    <Avatar
                      src={comment?.author?.profile_pic}
                      sx={{
                        mr: 1.5,
                        width: 32,
                        height: 32,
                        border: "1px solid #e0e0e0",
                      }}
                    />
                    <TextField
                      value={replyText}
                      onChange={(e) => setReplyText(e.target.value)}
                      onKeyDown={(e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault(); // Prevents new line
        handleAddReply(postId, comment?.id); // 👈 Called on Enter
      }
    }}
                      size="small"
                      fullWidth
                      placeholder="Write a reply..."
                    />
                    <Button
                      onClick={() => handleAddReply(postId, comment?.id)}
                      sx={{ ml: 1, textTransform: "none" }}
                    >
                      Post
                    </Button>
                  </Box>
                )}
              </Box>
            ))}
           </Box>
          </Box>
        )}
        <FeedViewModal
          open={modalOpen}
          onClose={handleCloseModal}
          feed={selectedFeed}
        />
      </Card>
      {/* Delete Confirmation Dialog */}
      <Dialog open={isDeleteModalOpen} onClose={handleCloseDeleteModal}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this post?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteModal} color="primary">
            No
          </Button>
          <Button onClick={handleDeleteClick} color="error">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {/* Edit Modal */}
      {isEditModalOpen && (
        <CreateFeedModal
          open={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          initialContent={editContent}
          initialMedia={editMedia}
          onSubmit={handleUpdatePost}
          isEditMode={true} // Pass a flag to indicate edit mode
          postId={postId}
          author={author}
        />
      )}

      <ShareProfile
              qrCodeUrl={`${window.location.origin}/explore/feeds/${postId}`}
              open={shareModalOpen}
              onClose={() => setShareModalOpen(false)}
              profileType="feeds"
              showQr={true}
              isDownload={false}
              handleSuccess={handleShareSuccess}
              handleFailure={handleShareFailure}
              shareData={{
                 title: item?.content?.substring(0, 100) || "Check out this post on NEOIN",
                 description: `Posted by ${item?.author?.name}`,
                 image: item?.media?.[0]?.url || (author?.profile_pic ? author.profile_pic : "default_image_url"),
                 url: `${window.location.origin}/explore/feeds/${item?.id}`,
              }}
            />
    </>
  );
};

export default FeedCard;
